import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { teal } from '@mui/material/colors';
import { orange } from '@mui/material/colors';

import { Provider } from 'react-redux';
import store from './store'

const theme = createTheme({
    palette: {
        primary: {
            main: teal[500],
        },
        neutral: {
            main: '#64748B',
            contrastText: '#fff',
        },
        youtube: {
            main: '#f50057',
            contrastText: '#fff',
        },
    },
    status: {
        danger: orange[500],
    },
});

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <CssBaseline />
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);
